var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachmentPdf = function SvgAttachmentPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    fillRule: "evenodd",
    d: "M12 7.5A1.5 1.5 0 0 0 10.5 9v8.25h3V7.5H12Zm1.5 23.25h-3v9.75A1.5 1.5 0 0 0 12 42h24a1.5 1.5 0 0 0 1.5-1.5v-.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M13.5 30.75h.75v7.5c0 .414.336.75.75.75h24a.75.75 0 0 0 .75-.75V14.155l-.244-.28H33V6.393L32.658 6H15a.75.75 0 0 0-.75.75v10.5h-.75V6.75a1.5 1.5 0 0 1 1.5-1.5h18l7.5 8.625V38.25a1.5 1.5 0 0 1-1.347 1.492L39 39.75H15a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-7.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    fillRule: "evenodd",
    d: "M31.13 29.625v-11.25c0-.621-.504-1.125-1.125-1.125H14.25V6.75A.75.75 0 0 1 15 6h17.658l.342.393v7.482h6.506l.244.28V38.25A.75.75 0 0 1 39 39H15a.75.75 0 0 1-.75-.75v-6h15.375a1.5 1.5 0 0 0 1.5-1.5v-1.023a1.11 1.11 0 0 0 .005-.102Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M27.505 30.75H14.25v1.5h15.375a1.5 1.5 0 0 0 1.5-1.5v-1.023a1.128 1.128 0 0 1-1.12 1.023h-2.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5255",
    d: "M10.5 17.25H9.005c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h21c.586 0 1.067-.45 1.12-1.023l.005-.102v-11.25c0-.621-.504-1.125-1.125-1.125H10.5Zm1.04 9.625v-6.363h2.39c1.46 0 2.238.887 2.242 2.11-.004 1.216-.791 2.1-2.259 2.1h-1.23v2.153H11.54Zm11.813 0v-6.363h4.078v.958h-2.936v1.74h2.654v.958h-2.654v2.707h-1.142Zm-4.096 0h-2.162v-6.363h2.197c1.898 0 3.045 1.19 3.05 3.173-.005 1.99-1.151 3.19-3.085 3.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5255",
    d: "M19.195 25.882h-.958v-4.377h.994c1.296-.005 1.968.72 1.968 2.18 0 1.467-.672 2.201-2.004 2.197Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5255",
    fillRule: "evenodd",
    d: "M13.755 23.781h-1.072V21.47h1.072c.861 0 1.248.47 1.248 1.151 0 .673-.387 1.156-1.248 1.16Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.353 20.512v6.363h1.142v-2.707h2.654v-.958h-2.654v-1.74h2.936v-.958h-4.078Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.257 26.875h-2.162v-6.363h2.197c1.898 0 3.045 1.19 3.05 3.173-.005 1.99-1.151 3.19-3.085 3.19Zm1.942-3.19c0 1.467-.672 2.201-2.004 2.197h-.958v-4.377h.994c1.296-.005 1.968.72 1.968 2.18Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.54 20.512v6.363h1.143v-2.153h1.23c1.468 0 2.255-.884 2.259-2.1-.005-1.223-.782-2.11-2.241-2.11h-2.39Zm2.215 3.27h-1.072V21.47h1.072c.861 0 1.248.47 1.248 1.151 0 .673-.387 1.156-1.248 1.16Z"
  })));
};
export default SvgAttachmentPdf;